import { html, render } from 'lit';
export class Progress {
    static openProgress(content) {
        if (!this.container) {
            this.container = document.createElement('div');
            document.body.appendChild(this.container);
        }
        const progressContent = html `<ggo-progress
      style="position: fixed;
        top: 10px;
        right: 10px;
        z-index: 1000;"
      >${content}</ggo-progress
    >`;
        render(progressContent, this.container);
    }
    static start(text) {
        console.log('start');
        this.openProgress(text);
    }
    static stop() {
        if (this.container) {
            this.container.remove();
            this.container = undefined;
        }
    }
}
